<template>
  <div class="repeat-custom-subform">
    <div class="first-row">
      <number-input
        :disabled='disabled'
        :title="$t('test.repeat.repeatEvery')"
        v-model="value.repeatEveryNumber"
        :min="1"
        class="repeat-every-number"
      />
      <Select v-model="safeRepeatEvery" :options="repeatEveryItems" size="xsmall" class="repeat-every dialog-time-picker" :disabled='disabled'/>
    </div>

    <buttons-switcher v-if="isWeekChosen" v-model="value.repeatOn" :items="repeatOnItems" :title="$t('test.repeat.repeatOn')" :disabled='disabled'/>
  </div>
</template>

<script>
import moment from 'moment';

import Select from '@/components/common/Select.vue';
import { TEST_REPEAT_EVERY } from '@/constants/projects';
import NumberInput from '@/components/common/NumberInput.vue';
import ButtonsSwitcher from '@/components/common/ButtonsSwitcher.vue';

export default {
  name: 'RepeatCustomSubform',
  components: {
    Select,
    NumberInput,
    ButtonsSwitcher,
  },
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    title: String,
  },
  computed: {
    isWeekChosen() {
      return this.safeRepeatEvery === TEST_REPEAT_EVERY.week;
    },
    repeatEveryItems() {
      return Object.values(TEST_REPEAT_EVERY).map(item => ({
        value: item,
        title: this.$t(`test.repeat.${item}`),
      }));
    },
    repeatOnItems() {
      return Array(7)
        .fill(0)
        .map((value, index) => moment()
          .weekday(index)
          .format('ddd'))
        .map(day => ({
          value: day,
          title: day.slice(0, 1),
        }));
    },
    safeRepeatEvery: {
      get() {
        return this.value.repeatEvery || '';
      },
      set(value) {
        if (!this.disabled) {
          this.value.repeatEvery = value;
        }
      },
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.$emit('input', {
        ...{
          repeatEveryNumber: 1,
          repeatEvery: TEST_REPEAT_EVERY.month,
        },
        ...this.value,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.repeat-custom-subform {
  display: flex;
  flex-direction: column;
}

.first-row {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  margin-bottom: 15px;
}

.repeat-every {
  min-width: 140px;
  width: 140px;
  height: 28px;
  margin-left: 8px;
}
</style>
